import { useTranslation } from 'react-i18next'
import { ECampaignStatus, ECampaignType, THRCampaign } from 'src/types/hr'
import { twMerge } from 'src/utils/tw-merge.util'
import { getFormattedDateWithHours } from 'src/utils/date-formatter.util'

export const CampaignHeader = ({ campaign }: Readonly<{ campaign: THRCampaign }>) => {
  const { t } = useTranslation()

  const campaignTypeLabels: Record<ECampaignType, string> = {
    [ECampaignType.ALERT]: t('pages.hr.campaigns.type.ALERT'),
    [ECampaignType.PLAN_BLANC]: t('pages.hr.campaigns.type.PLAN_BLANC'),
  }
  const campaignStatusLabels: Record<ECampaignStatus, string> = {
    [ECampaignStatus.SENDING]: t('pages.hr.campaigns.status.SENDING'),
    [ECampaignStatus.SENT]: t('pages.hr.campaigns.status.SENT'),
  }

  return (
    <div className="c-flex c-items-center c-gap-3 c-mb-6 c-flex-wrap c-min-w-0">
      <span
        className={twMerge(
          'c-px-2 c-py-0.5 c-rounded-full c-text-xs c-font-medium c-shrink-0',
          campaign.type === ECampaignType.PLAN_BLANC
            ? 'c-bg-blue-200 c-text-blue-600'
            : 'c-bg-red-100 c-text-red-700',
        )}
      >
        {campaignTypeLabels[campaign.type]}
      </span>
      <span
        className={twMerge(
          'c-px-2 c-py-0.5 c-rounded-full c-text-xs c-font-medium c-shrink-0',
          campaign.status === ECampaignStatus.SENT
            ? 'c-bg-green-100 c-text-green-700'
            : 'c-bg-yellow-100 c-text-yellow-700',
        )}
      >
        {campaignStatusLabels[campaign.status]}
      </span>
      <span className="c-text-sm c-text-grey-500 c-shrink-0">
        {getFormattedDateWithHours(t, campaign.sentAt)} · {campaign.recipientCount}{' '}
        {t('pages.hr.campaigns.table.recipient-count').toLowerCase()}
      </span>
      <span className="c-flex c-items-center c-bg-grey-100 c-text-grey-700 c-rounded-2xl c-px-3 c-py-1 c-text-sm c-min-w-0 c-flex-1 c-overflow-hidden c-truncate">
        {campaign.message}
      </span>
    </div>
  )
}
